import React, {useState, useEffect, useContext} from "react";
import Menu from "@common/Menu";
import MenuItem from "@common/MenuItem";
import IconButtonsGroup from "./IconButtonsGroup";
import IconButton from "./IconButton";
import {MoreVertIcon} from "./icons";

const PositionedMenu = props => {
    const {children, label} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <IconButton
                aria-label={label ? 'toggle ' + label : undefined}
                onClick={handleClick}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                aria-label={label}
            >
                {children}
            </Menu>

        </div>
    );
}

export default PositionedMenu;